// Lazy loading script for FourSixty (fs) background images
function setupFSBackgroundImageLazyLoading() {
  // Target the FourSixty container and its entries
  const fsContainer = document.getElementById('fsContainer')
  if (!fsContainer) return

  // Function to extract background image URL from CSS
  function getBackgroundImageUrl(element) {
    const style = window.getComputedStyle(element)
    const backgroundImage = style.backgroundImage

    if (backgroundImage && backgroundImage !== 'none') {
      // Extract URL from background-image: url('...') or url("...")
      const match = backgroundImage.match(/url\(['"]?([^'"]+)['"]?\)/)
      return match ? match[1] : null
    }
    return null
  }

  // Function to set background image
  function setBackgroundImage(element, imageUrl) {
    element.style.backgroundImage = `url('${imageUrl}')`
    element.classList.add('fs-image-loaded')
    element.classList.remove('fs-image-loading')
  }

  // Function to set placeholder
  function setPlaceholder(element) {
    // Create a subtle placeholder background
    element.style.backgroundImage = 'none'
    element.style.backgroundColor = '#f5f5f5'
    element.classList.add('fs-image-loading')
  }

  // Create intersection observer for lazy loading
  const imageObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const entryDiv = entry.target

          // Only load if not already loaded
          if (!entryDiv.dataset.fsLoaded) {
            entryDiv.dataset.fsLoaded = 'true'

            // Get the original background image URL
            const originalImageUrl = entryDiv.dataset.fsOriginalImage

            if (originalImageUrl) {
              // Preload the image
              const tempImg = new Image()
              tempImg.onload = () => {
                setBackgroundImage(entryDiv, originalImageUrl)
              }
              tempImg.onerror = () => {
                console.warn('Failed to load FourSixty image:', originalImageUrl)
                entryDiv.classList.remove('fs-image-loading')
              }

              // Start loading
              tempImg.src = originalImageUrl
            }

            // Stop observing this element
            observer.unobserve(entryDiv)
          }
        }
      })
    },
    {
      rootMargin: '100px 0px', // Start loading 100px before entering viewport
      threshold: 0.1,
    }
  )

  // Function to process FourSixty entries
  function processFSEntries() {
    const entryContainers = fsContainer.querySelectorAll('.fs-entry-container')

    entryContainers.forEach((container) => {
      const timelineEntry = container.querySelector('.fs-timeline-entry')

      if (timelineEntry) {
        // Get the original background image
        const originalImageUrl = getBackgroundImageUrl(timelineEntry)

        if (originalImageUrl) {
          // Store the original image URL
          timelineEntry.dataset.fsOriginalImage = originalImageUrl

          // Set placeholder
          setPlaceholder(timelineEntry)

          // Start observing for intersection
          imageObserver.observe(timelineEntry)
        }
      }
    })
  }

  // Function to watch for dynamically added content
  function setupMutationObserver() {
    const observer = new MutationObserver((mutations) => {
      let shouldProcess = false

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if the added node contains FourSixty entries
            if (node.classList && node.classList.contains('fs-entry-container')) {
              shouldProcess = true
            }

            // Check for entries within added nodes
            if (node.querySelector && node.querySelector('.fs-entry-container')) {
              shouldProcess = true
            }
          }
        })
      })

      // Process new entries if any were added
      if (shouldProcess) {
        // Small delay to ensure DOM is fully updated
        setTimeout(processFSEntries, 100)
      }
    })

    observer.observe(fsContainer, {
      childList: true,
      subtree: true,
    })
  }

  // Initial processing
  processFSEntries()

  // Set up mutation observer for dynamic content
  setupMutationObserver()

  // Also process on window load in case images are added after DOM ready
  window.addEventListener('load', () => {
    setTimeout(processFSEntries, 500)
  })
}

// Run when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupFSBackgroundImageLazyLoading)
} else {
  setupFSBackgroundImageLazyLoading()
}

// Export for potential external use
window.setupFSBackgroundImageLazyLoading = setupFSBackgroundImageLazyLoading
